import { Box, Container, Grid2, Paper } from "@mui/material";
import {
  getRoute,
  PAYMENT_PLAN_DETAIL_PUBLIC_ACCESS,
} from "Infrastructure/config/routesConfig";
import Loader from "pages/components/Loader";
import LanguageSwitcher from "pages/translations/LanguageSwitcher";
import { matchPath } from "react-router-dom";

export default function PublicLayout({ children }: any) {
  return (
    <Grid2
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: "100vh", bgcolor: "primary.main" }}
    >
      <Container
        maxWidth={isFullPage() ? "xl" : "sm"}
        style={{ position: "relative" }}
      >
        <Container
          style={{
            position: "absolute",
            left: "auto",
            right: 0,
            top: 0,
            zIndex: 100,
            width: "fit-content",
            display: "grid",
          }}
        >
          <LanguageSwitcher tiny={true} />

          <Box sx={{ padding: 0.5 }}>
            <Loader />
          </Box>
        </Container>

        <Paper elevation={10} sx={{ padding: 2 }}>
          {children}
        </Paper>
      </Container>
    </Grid2>
  );
}

function isFullPage() {
  const fullPageRoutes = [PAYMENT_PLAN_DETAIL_PUBLIC_ACCESS];
  for (var i = 0; i < fullPageRoutes.length; i++) {
    if (
      matchPath({ path: getRoute(fullPageRoutes[i]) }, window.location.pathname)
    ) {
      return true;
    }
  }
  return false;
}
